export const stripPathParams = (navLink: string) => navLink.split('/').slice(0, 2).join('/');

export const mapStripPathParams = (navLinks: string[]) =>
  navLinks.map((navLink) => stripPathParams(navLink));
